module.exports = __webpack_public_path__ + "media/images/default-training-image-5d4125eb2ccaa582ce83b71587f78aa4.png";